'use client'
import { PortableText } from '@portabletext/react'
import { getPortableTextComponents } from 'app/components/PortableTextComponents'

import { CategorySidebarNav } from './CategorySidebarNav'
import { LinkCard } from './LinkCard'

export function TopicBody({ data }: any) {
  return (
    <div className="min-h-screen flex max-w-[var(--max-width)] mx-auto relative">
      <CategorySidebarNav category={data} selected={data.category && data.category.slug} />
      <div className="min-h-full relative border-green-100 border-l">
        <div className="max-w-4xl p-4 md:p-8 lg:p-16">
          <header className="border-green-100s mb-5 border-b pb-5">
            <h1 className="mb-5 text-3xl md:text-4xl lg:text-5xl font-semibold">
              {data.title}
            </h1>
            <PortableText
              value={data.description || []}
              components={getPortableTextComponents()}
            />
            {/* <div className="text-lg text-green-900">
        {data.description && toPlainText(data.description)}
      </div> */}
          </header>
          <div className="grid grid-cols-12 gap-8">
            {data.articles &&
              data.articles.map(
                (article: {
                  slug: string
                  _type: string
                  title: string
                  description: string
                }) => (
                  <LinkCard
                    key={article.slug}
                    title={article.title}
                    description={article.description}
                    link={`/${data.category.slug}/${data.slug}/${article.slug}`

                    }
                  />
                ),
              )}
          </div>
        </div>
      </div>
    </div>
  )
}
